module.exports = __webpack_public_path__ + "img/pk_icon.6239364a.png";